import React, { Fragment, useEffect, useMemo, useState } from "react";

import Loader from "../Shared/Loader";
import EditableField from "components/Shared/EditableField";
import DraggableColumnTable from "components/Shared/CustomTable/DraggableTableColumns/DraggableColumnTable";
import { useSelector } from "react-redux";
import { selectPeriodTypesByTeam } from "store/hooks/periodTypes";
import { PeriodTypeUI } from "store/types";

const loaderProps = {
  style: { top: "0" },
};

type Props = {
  editable: boolean;
  teamId: string;
  periodTypesCopy: PeriodTypeUI[];
  setPeriodTypesCopy: React.Dispatch<React.SetStateAction<any>>;
};

const PeriodsTypes = ({
  editable,
  teamId,
  periodTypesCopy,
  setPeriodTypesCopy,
}: Props) => {
  const periodTypes = useSelector(selectPeriodTypesByTeam(teamId));

  useEffect(() => {
    if (!periodTypes) return;
    setPeriodTypesCopy(periodTypes);
  }, [teamId, periodTypes]);

  const onChangeRows = (indexA: number, indexB: number) => {
    const newPeriodTypePos = [...periodTypesCopy];
    const movedPeriodType = newPeriodTypePos[indexA];

    newPeriodTypePos.splice(indexA, 1);
    newPeriodTypePos.splice(indexB, 0, movedPeriodType);
    const updated = newPeriodTypePos.map((item, index) => ({
      ...item,
      pos: String(index + 1),
    }));

    setPeriodTypesCopy(updated);
  };

  const handleAddPeriodType = () => {
    const newItem: PeriodTypeUI = {
      id: crypto.randomUUID(),
      pos: 0,
      name: "",
      isEditable: true,
    };

    setPeriodTypesCopy((prev: any) => [newItem, ...prev]);
  };

  const handleRemovePeriodType = (index: number) => {
    setPeriodTypesCopy((prev: any[]) => prev.filter((_, i) => i !== index));
  };

  const handlePeriodTypeName = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const value = event.target.value;

    setPeriodTypesCopy((prev: any) => {
      const copy = [...prev];
      copy[index] = { ...copy[index], name: value };
      return copy;
    });
  };

  const headers = [
    { content: "Period Type" },
    { content: "" },
    { content: " " },
  ];

  const rows = useMemo(() => {
    return periodTypesCopy.map((data: PeriodTypeUI, index: any) => ({
      columns: [
        {
          content: index + 1,

          style: {
            padding: "19px 20px 19px 0px",
            textAlign: "left",
            width: "60px",
          },
          isDragHandle: editable,
          print: (content: any) => (
            <Fragment>
              {editable && (
                <img
                  src="/assets/dots.svg"
                  alt=""
                  height="15px"
                  style={{ marginTop: "-2px", marginRight: "3px" }}
                />
              )}
              <span
                style={
                  editable
                    ? { float: "right" }
                    : { marginRight: "5px", fontWeight: "bold" }
                }
              >
                {editable ? content : content + " - "}
              </span>
            </Fragment>
          ),
        },
        {
          content: data.name,
          style: { textAlign: "left" },
          class: "tt-qq",
          isDragHandle: true,
          print: (content: any) => (
            <>
              <EditableField
                itemId={index as number}
                editable={editable && data.isEditable}
                text={content}
                handleChange={handlePeriodTypeName}
                isCustomValue={true}
              />
            </>
          ),
        },
        {
          style: {
            color: "#4F9300",
            fontWeight: "bold",
            fontSize: "13px",
            padding: "19px 0px 19px 20px",
          },
          print: () => (
            <>
              {editable && data.isEditable ? (
                <button
                  className="trash-00"
                  onClick={() => handleRemovePeriodType(index)}
                >
                  <img src="/assets/trash.svg" alt="" height="20px" />
                </button>
              ) : (
                ""
              )}
            </>
          ),
        },
      ],
      draggable: editable,
      id: data.id,
    }));
  }, [periodTypesCopy, editable]);

  return (
    <>
      <div style={{ height: "100%" }} className="periods-table-box">
        <Loader {...loaderProps}>
          <div
            style={
              editable
                ? { height: "calc(100% - 48px)", overflowX: "auto" }
                : { height: "calc(100% - 10px)", overflowX: "auto" }
            }
          >
            {/* @ts-ignore */}

            <DraggableColumnTable
              rows={rows}
              headers={headers}
              onChangeRows={onChangeRows}
            />
          </div>
        </Loader>
        <div
          onClick={handleAddPeriodType}
          style={{
            background: "#F5F5F5",
            zIndex: 7,
            display: editable ? undefined : "none",
            height: "48px",
            width: "100%",
            fontSize: "25px",
            textAlign: "center",
            fontWeight: 500,
            color: "#007ABA",
            cursor: "pointer",
            // boxShadow: '0px 0px 3px rgba(0,0,0,0.3)',
            fontFamily: "Roboto",
            position: "relative",
            bottom: "0",
          }}
        >
          <label
            className="ll-m-01"
            style={{
              fontSize: "36px",
              lineHeight: "20px",
              cursor: "pointer",
              position: "absolute",
              top: "12px",
              left: "calc(45%)",
            }}
          >
            +
          </label>
          <label
            className="ll-m-02"
            style={{
              fontSize: "14px",
              lineHeight: "20px",
              cursor: "pointer",
              position: "absolute",
              top: "14px",
              left: "calc(45% + 26px)",
            }}
          >
            Add Period Type
          </label>
        </div>
      </div>
    </>
  );
};
export default PeriodsTypes;
